import { useEffect, useState } from 'react';
import ENV from '../../../constants/Env';
import { makeStyles } from '@material-ui/core';

const DROPDOWN_OVERFLOW_BUFFER = 350;

const useStyles = makeStyles(() => ({
  layout: {
    marginTop: '10px',
  },
  iframe: {
    minHeight: '750px',
    width: '100%',
    border: 'none',
  },
}));

type PortalDriverPreferencesTabProps = {
  riderId: string;
};

export function PortalDriverPreferencesTab({
  riderId,
}: PortalDriverPreferencesTabProps) {
  const driverPreferencesUrl = `${ENV.portalUrl}/riders/${riderId}/driver-preferences?embeddedInDashboard=true`;
  const classes = useStyles();
  const [iframeHeight, setIframeHeight] = useState<number | null>(null);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== ENV.portalUrl) {
        return;
      }

      const { data } = event;

      if (data.action === 'DRIVER_PREFERENCES_HEIGHT') {
        const height = Number(data.height);

        if (!isNaN(height) && height > 0) {
          setIframeHeight(height + DROPDOWN_OVERFLOW_BUFFER);
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => window.removeEventListener('message', handleMessage);
  }, []);

  return (
    <div className={classes.layout}>
      <iframe
        data-test-id="portal-iframe"
        title="Portal Driver Preference"
        src={driverPreferencesUrl}
        className={classes.iframe}
        style={{
          height: iframeHeight ? `${iframeHeight}px` : '0px',
        }}
      />
    </div>
  );
}
